import { render, staticRenderFns } from "./AutoQPBuilder.vue?vue&type=template&id=2cf6c4b3"
import script from "./AutoQPBuilder.vue?vue&type=script&lang=js"
export * from "./AutoQPBuilder.vue?vue&type=script&lang=js"
import style0 from "./AutoQPBuilder.vue?vue&type=style&index=0&id=2cf6c4b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports